import { type IConfig } from '@cian/config/shared';

import { type IPromo } from '../../../types/promos';
import { getCianMortgagePromoUrl } from '../../../utils/getCianMortgagePromoUrl';

export function getMortgagePartnerLink(promo: IPromo | null, config: IConfig): string | null {
  if (promo?.bank?.isPartner && promo?.promoType !== 'maternalCapital') {
    return getCianMortgagePromoUrl(config);
  }

  return null;
}
